import tw, { styled } from 'twin.macro';
import Icon from '@/components/Icon/IconSprite';

export const CheckedIcon = styled(Icon)`
  ${tw`w-[24px]`}
  ${tw`hidden`}
  ${tw`text-primary-p1 dark:text-neutrals-n2`}
`;

export const UncheckedIcon = styled(Icon)`
  ${tw`w-[24px]`}
  ${tw`text-primary-p1 dark:text-neutrals-n2`}
`;

export const StyledInput = styled.input`
  ${tw`hidden`}

  &:checked {
    & ~ ${CheckedIcon} {
      ${tw`block`}
    }

    & ~ ${UncheckedIcon} {
      ${tw`hidden`}
    }
  }
`;

export const StyledContainer = styled.div<{ isDisabled?: boolean }>`
  ${tw`flex gap-[12px] self-start`}
  ${tw`relative`}

  ${CheckedIcon}, ${UncheckedIcon} {
    ${tw`absolute left-0`}
    ${tw`pointer-events-none`}
  }

  ${({ isDisabled }) => isDisabled && tw`cursor-not-allowed opacity-50`}
`;

export const StyledLabel = styled.label`
  ${tw`cursor-pointer`}
  ${tw`font-inter font-regular`}
  ${tw`text-body-s text-primary-p1 dark:text-neutrals-n2`}
  ${tw`pl-[36px]`}
`;
